import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

const SEO = ({ 
  title, 
  description, 
  keywords,
  image,
  type = 'website',
  author,
  publishedDate,
  modifiedDate,
  lang = 'it'
}) => {
  const location = useLocation();
  const siteUrl = 'https://magicomms.com'; // Update this to your final domain
  const currentUrl = `${siteUrl}${location.pathname}`;
  
  const defaultTitle = 'Magicomms - Communications Agency';
  const defaultDescription = 'Magicomms is a PR & Communications Agency specializing in media relations, press office, corporate and sports communications.';
  const defaultKeywords = 'agenzia comunicazione roma, agenzia PR roma, ufficio stampa roma, comunicazione sportiva, media relations, crisis management, comunicazione corporate, digital content';
  const defaultImage = `${siteUrl}/og-image.jpg`;

  const seoTitle = title ? `${title} | Magicomms` : defaultTitle;
  const seoDescription = description || defaultDescription;
  const seoKeywords = keywords || defaultKeywords;
  const seoImage = image || defaultImage;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <html lang={lang} />
      <title>{seoTitle}</title>
      <meta name="title" content={seoTitle} />
      <meta name="description" content={seoDescription} />
      <meta name="keywords" content={seoKeywords} />
      
      {/* Canonical URL */}
      <link rel="canonical" href={currentUrl} />
      
      {/* Alternate Language Tags */}
      <link rel="alternate" hrefLang="it" href={currentUrl} />
      <link rel="alternate" hrefLang="en" href={currentUrl} />
      <link rel="alternate" hrefLang="x-default" href={currentUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={currentUrl} />
      <meta property="og:title" content={seoTitle} />
      <meta property="og:description" content={seoDescription} />
      <meta property="og:image" content={seoImage} />
      <meta property="og:locale" content={lang === 'it' ? 'it_IT' : 'en_US'} />
      <meta property="og:site_name" content="Magicomms" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={currentUrl} />
      <meta name="twitter:title" content={seoTitle} />
      <meta name="twitter:description" content={seoDescription} />
      <meta name="twitter:image" content={seoImage} />

      {/* Article specific tags */}
      {type === 'article' && author && (
        <meta property="article:author" content={author} />
      )}
      {type === 'article' && publishedDate && (
        <meta property="article:published_time" content={publishedDate} />
      )}
      {type === 'article' && modifiedDate && (
        <meta property="article:modified_time" content={modifiedDate} />
      )}

      {/* Additional SEO */}
      <meta name="robots" content="index, follow" />
      <meta name="googlebot" content="index, follow" />
      <meta name="language" content={lang === 'it' ? 'Italian' : 'English'} />
      <meta name="revisit-after" content="7 days" />
      <meta name="author" content="Magicomms" />
    </Helmet>
  );
};

export default SEO;
